import { dispatch } from 'react-hot-toast/dist/core/store'
import { connect } from 'react-redux'
import { RidersPerPromotion } from 'src/components/promotions/RidersPerPromotion'
import { getRidersPerPromotion } from '../../state/actions/organizations'
import { IGetRidersPerPromotion, IStoreState } from 'src/types'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    promotionId: ownProps.match.params.promotionId,
    riders: state.organizationPromotions.riders,
    riderCount: state.organizationPromotions.riderCount,
    promotion: state.organizationPromotions.items[ownProps.match.params.promotionId]
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getRidersPerPromotion: (params: IGetRidersPerPromotion) => dispatch(getRidersPerPromotion(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RidersPerPromotion)



// WEBPACK FOOTER //
// ./src/containers/promotions/RidersPerPromotion.ts